module.exports = __webpack_public_path__ + "img/euphoric.75d586bc.png";